type FullSentry = typeof import('@sentry/react');

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    Sentry?: FullSentry;
  }
}

// This is a minimal version of the Sentry API provided by the sentry_loader.js script.
type MinimalSentry = Pick<
  FullSentry,
  'init' | 'captureException' | 'captureMessage' | 'captureEvent' | 'addBreadcrumb' | 'withScope'
> &
  Partial<
    Omit<
      FullSentry,
      | 'init'
      | 'captureException'
      | 'captureMessage'
      | 'captureEvent'
      | 'addBreadcrumb'
      | 'withScope'
    >
  >;

let SentryInstance: FullSentry | MinimalSentry | undefined = window.Sentry;

export const getInstance = () => SentryInstance;

export const internalSetInstance = (instance: any) => {
  window.Sentry = instance;
  SentryInstance = instance;
};
